
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M21.285 12.336v-.163c4.608 0 5.082-.476 5.082-5.084h.165c0 4.608.475 5.084 5.083 5.084v.163c-4.608 0-5.083.476-5.083 5.084h-.165c0-4.608-.474-5.084-5.082-5.084zM30.66 1.954a6.14 6.14 0 00-.422-.635 1.9 1.9 0 00-.497-.454 2.068 2.068 0 00-.687-.264 5.009 5.009 0 00-1.015-.084L24.96.5a5.07 5.07 0 00-1.014.084 2.068 2.068 0 00-.687.264 1.9 1.9 0 00-.497.455 6 6 0 00-.422.634l-6.877 11.534c-.126.212-.239.38-.337.508a1.148 1.148 0 01-.307.284.98.98 0 01-.37.128c-.06.008-.451.015-.607.015h-.91c-.224 0-.407-.011-.549-.032a.98.98 0 01-.37-.127 1.143 1.143 0 01-.305-.285 5.292 5.292 0 01-.339-.507L3.762.5H0l9.256 15.47c.14.24.282.45.423.633.14.183.306.335.496.455s.42.207.688.264c.267.056.605.085 1.014.085l3.079.016c.409 0 .747-.028 1.014-.085a2.08 2.08 0 00.687-.263c.19-.12.357-.272.497-.455.141-.182.282-.394.423-.634l6.876-11.534a5.29 5.29 0 01.338-.508c.098-.126.2-.221.306-.285.106-.063.23-.105.37-.126.06-.01.452-.015.607-.015h.91c.224 0 .408.01.549.032.14.021.264.063.37.126.104.064.208.159.306.285.098.127.21.296.338.508l7.608 12.954h3.76L30.66 1.954z"}})])
          )
        }
      }
    